import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import SellingService from "../services/SellingService";
import WarehouseService from "../services/WarehouseService";
import toastr from "toastr";

const ModifierStockModal = ({ show, onClose, product, type, idWarehouse, idUser ,refrech, setRefrech }) => {
  const [quantite, setQuantite] = useState(product ? product[type] : 0);

  const handleSave = async () => {
    

    try {
      if (type === "qteMin") {
        await WarehouseService.addStockMinToProductStock(idUser, idWarehouse, product.product.barcode, quantite);
      } else {
        await WarehouseService.addStockMaxToProductStock(idUser, idWarehouse, product.product.barcode, quantite);
      }
      toastr.success(`${type === "qteMin" ? "Stock minimum" : "Stock maximum"} mis à jour avec succès !`);
      onClose();
      setRefrech(!refrech)
    } catch (error) {
      console.error("Erreur lors de la mise à jour du stock :", error);
    //   alert("Échec de la mise à jour du stock.");
    }
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Modifier le stock {type === "qteMin" ? "minimum" : "maximum"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <strong>Code barre du produit : {product?.product?.barcode}</strong>
        <Form.Group>
          <Form.Label>Nouvelle quantité {type === "qteMin" ? "minimale" : "maximale"}</Form.Label>
          <Form.Control
            type="number"
            value={quantite}
            step="0.01"
            onChange={(e) => setQuantite(parseFloat(e.target.value) || 0)}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Annuler
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Enregistrer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModifierStockModal;
